module.exports = __webpack_public_path__ + "static/media/laptop-medical.6b851c31.svg";